import { useDocumentParams } from 'app/router/params';
import { useUser } from 'app/state/contexts';
import { useGetDocument, DesignEntry, DraftStyleEntry } from 'entities/document';
import { useStyle } from 'entities/style';
import { useDraft, useSaveDraft } from 'entities/draft';

interface UseDesignDraftOptions {
  styleType: string;
  parsed?: boolean;
}

type DesignDraftView = {
  type?: string;
  styleId?: string;
  style?: unknown;
  metadata?: Record<string, unknown>;
  toolbarEntries?: unknown;
  scopeEntries?: unknown;
  slots?: Record<string, string>;
  [key: string]: unknown;
};

export function useDesignDraft({ styleType, parsed = true }: UseDesignDraftOptions) {
  const { documentId } = useDocumentParams();
  const { selectedOrganization } = useUser();

  const pDocument = useGetDocument(documentId, selectedOrganization);
  const designEntry = pDocument.data?.content.design.find((d: DesignEntry) => d.type === styleType);
  const styleId = designEntry?.styleId;

  const style = useStyle({
    organization: selectedOrganization,
    documentRevisionId: pDocument.data?.revisionId,
    styleId,
    parsed,
  });

  const draft = useDraft({ documentSuperId: documentId });
  const draftContent = (draft.data as { content?: DraftStyleEntry[] } | undefined)?.content;
  const draftEntry = draftContent?.find((s) => s.type === styleType);
  const { mutate: saveDraft } = useSaveDraft();

  return {
    documentId,
    pDocument,
    designEntry: designEntry as DesignDraftView | undefined,
    style,
    draft,
    draftEntry: draftEntry as DesignDraftView | undefined,
    saveDraft,
  };
}
